// Ahora importar los estilos
import "/css/tailwind.css";
import "/scss/app.scss";

// =============================================
// ESPERAR SOLO A LAS LIBRERÍAS CDN
// =============================================
function waitForLibraries() {
  return new Promise((resolve) => {
    let attempts = 0;
    const maxAttempts = 100;

    const checkLibraries = () => {
      attempts++;

      const checks = {
        gsap: typeof gsap !== "undefined",
        ScrollTrigger: typeof ScrollTrigger !== "undefined",
        CustomEase: typeof CustomEase !== "undefined",
        jQuery: typeof jQuery !== "undefined",
        Swiper: typeof Swiper !== "undefined",
        ajax: typeof ajax !== "undefined", // wp_localize_script lo crea
      };

      /* if (Object.values(checks).every(v => v === true)) {
                console.log('✅ Todas las librerías cargadas después de', attempts, 'intentos');
                resolve();
                return;
            }

            if (attempts >= maxAttempts) {
                console.error('❌ TIMEOUT: No se cargaron todas las librerías');
                console.log('Faltan:', Object.keys(checks).filter(k => !checks[k]));
                resolve();
                return;
            }

            if (attempts % 20 === 0) {
                console.log(`⏳ Esperando... intento ${attempts}`, checks);
            }*/

      setTimeout(checkLibraries, 50);
    };

    checkLibraries();
  });
}

// =============================================
// INICIALIZACIÓN
// =============================================
waitForLibraries().then(() => {
  console.log("=== APP INICIANDO ===");
  console.log("Ajax URL:", ajax.url);
  console.log("Ajax Nonce:", ajax.nonce);

  // Registrar plugins de GSAP
  gsap.registerPlugin(ScrollTrigger, CustomEase);
  if (ScrollTrigger.isTouch) {
    ScrollTrigger.config({
      ignoreMobileResize: true,
    });

    ScrollTrigger.normalizeScroll(true);
  }

  document.fonts.ready.then(() => {
    if (typeof SplitText !== "undefined") {
      gsap.registerPlugin(SplitText);
      window.SplitText = SplitText;
    }
  });

  window.gsap = gsap;
  window.ScrollTrigger = ScrollTrigger;
  window.CustomEase = CustomEase;

  console.log("✅ Iniciando app...");
  initApp();
});

function initApp() {
  console.log("✅ App inicializada correctamente");

  // =============================================
  // AQUÍ VA TU CÓDIGO EXISTENTE
  // =============================================
}
let scroll;

//if (history.scrollRestoration) {
//  history.scrollRestoration = 'manual';
//} else {
//  window.onbeforeunload = function () {
//      window.scrollTo(0, 0);
//  }
//}

const body = document.body;
const select = (e) => document.querySelector(e);
const selectAll = (e) => document.querySelectorAll(e);
//const container = select('.site-main');

initPageTransitions();

// Animation - First Page Load
function initLoader() {
  var tl = gsap.timeline();
  tl.set(".loading-screen", { top: "0" });
  //tl.set(".loading-screen .iso", { opacity: 1 });

  //const svgPaths = document.querySelectorAll(".draw-svg g path");
  //gsap.set(svgPaths, { drawSVG: "0% 0%" });

  //////////////////////
  //let path = null;
  const allPaths = [];
  const headings = document.querySelectorAll("#animated-heading");
  //document.fonts.ready.then(function () {
  headings.forEach((heading, index) => {
    if (heading) {
      const splitHeading = new SplitText(heading, {
        type: "words,lines",
        wordsClass: "word",
        linesClass: "line once-in",
      });
    }
  });
  //});
  ////////////////////

  if ($(window).width() > 540) {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "120vh" });
  } else {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "140vh" });
  }

  tl.set("main .once-in-left", { x: "-80vw" });
  tl.set("main .once-in-right", { x: "125vw" });

  tl.set("main .show-up", { opacity: 0 });

  tl.to(".loading-screen", {
    duration: 0.8,
    top: "-100%",
    ease: "Power4.easeInOut",
    delay: 1,
  });

  tl.to(".loading-words", { duration: 0.3, opacity: 0, ease: "linear" }, "=-1");

  tl.set(".loading-screen", { top: "calc(-100%)" });

  tl.to(
    ["main .once-in-inv", "main .once-in"],
    {
      duration: 1,
      y: "0vh",
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=-.3",
  );

  tl.to(
    ["main .once-in-left", "main .once-in-right"],
    {
      duration: 1,
      x: "0",
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=-.8",
  );

  tl.to(
    ["main .show-up"],
    {
      duration: 1.2,
      opacity: 1,
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=-.95",
  );
}

// Animation - Page transition In
function pageTransitionIn() {
  var tl = gsap.timeline();

  tl.set(".loading-screen", {
    top: "100%",
  });

  tl.set(".loading-words", {
    opacity: 0,
    y: 0,
  });

  tl.to(".loading-screen", {
    duration: 0.5,
    top: "0%",
    ease: "Power4.easeIn",
  });

  tl.to(".loading-words", {
    duration: 0.8,
    opacity: 1,
    ease: "Power4.easeOut",
    delay: 0.05,
  });

  tl.to(
    ".loading-screen",
    {
      duration: 0.8,
      top: "-100%",
      ease: "Power3.easeInOut",
    },
    "=-.2",
  );

  tl.to(
    ".loading-words",
    {
      duration: 0.6,
      opacity: 0,
      ease: "linear",
    },
    "=-.8",
  );

  tl.set(".loading-screen", {
    top: "100%",
  });

  tl.set(".loading-words", {
    opacity: 0,
  });
  if ($(window).width() > 540) {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "120vh" });
  } else {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "140vh" });
  }

  tl.set("main .once-in-left", { x: "-80vw" });
  tl.set("main .once-in-right", { x: "125vw" });

  tl.set("main .show-up", { opacity: 0 });
}

// Animation - Page transition Out
function pageTransitionOut() {
  var tl = gsap.timeline();
  //  const svgPaths = document.querySelectorAll(".draw-svg g path");
  //gsap.set(svgPaths, { drawSVG: "0% 0%" });

  //////////////////////
  //let path = null;
  const allPaths = [];
  const headings = document.querySelectorAll("#animated-heading");
  //document.fonts.ready.then(function () {
  headings.forEach((heading, index) => {
    if (heading) {
      const splitHeading = new SplitText(heading, {
        type: "words,lines",
        wordsClass: "word",
        linesClass: "line once-in",
      });
    }
  });
  //});
  ////////////////////

  if ($(window).width() > 540) {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "120vh" });
  } else {
    tl.set("main .once-in-inv", { y: "-140vh" });
    tl.set("main .once-in", { y: "140vh" });
  }

  tl.set("main .once-in-left", { x: "-80vw" });
  tl.set("main .once-in-right", { x: "125vw" });

  tl.set("main .show-up", { opacity: 0 });

  tl.to(
    ["main .once-in-inv", "main .once-in"],
    {
      duration: 1,
      y: "0vh",
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=.9",
  );

  tl.to(
    ["main .once-in-left", "main .once-in-right"],
    {
      duration: 1,
      x: "0",
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=-.8",
  );

  tl.to(
    ["main .show-up"],
    {
      duration: 1.2,
      opacity: 1,
      stagger: 0.05,
      ease: "Expo.easeOut",
      //clearProps: "true",
    },
    "=-.95",
  );

  tl.call(function () {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1800);
    $(".loader-container .loader").removeClass("blanco");
  });
}

///////////////////////////////////////////////////////

function initPageTransitions() {
  //let scroll;

  // do something before the transition starts
  barba.hooks.before(() => {
    // select('html').classList.add('is-transitioning');
  });

  // do something after the transition finishes
  barba.hooks.after(() => {
    //select('html').classList.remove('is-transitioning');
    // reinit locomotive scroll
    refreshCartCount();
  });

  // scroll to the top of the page
  barba.hooks.enter(() => {
    window.scrollTo(0, 0);
    $(" main ").removeClass("default").addClass("fijo");
  });

  // scroll to the top of the page
  barba.hooks.afterEnter(() => {
    if (
      document.querySelector("main#page-home") ||
      document.querySelector("main#page-quienes-somos")
    ) {
      if ($(document).scrollTop() > 170) {
        $(" main ").removeClass("default").addClass("fijo");
      } else {
        $(" main ").removeClass("fijo").addClass("default");
      }
      $(document).on("scroll", function () {
        if ($(document).scrollTop() > 170) {
          $(" main ").removeClass("default").addClass("fijo");
        } else {
          $(" main ").removeClass("fijo").addClass("default");
        }
      });
    } else {
      if ($(document).scrollTop() > 170) {
        $(" main ").removeClass("default").addClass("fijo");
      } else {
        $(" main ").removeClass("fijo").addClass("fijo");
      }
      $(document).on("scroll", function () {
        if ($(document).scrollTop() > 170) {
          $(" main ").removeClass("default").addClass("fijo");
        } else {
          $(" main ").removeClass("fijo").addClass("fijo");
        }
      });
    }

    window.scrollTo(0, 0);
    initCookieViews();
  });

  if ($(window).width() > 540) {
    barba.hooks.leave(() => {
      $(".btn-hamburger, .btn-menu").removeClass("active");
      $("main").removeClass("nav-active");
    });
  }

  ////////////////////////////////////////

  barba.init({
    sync: true,
    debug: false,
    logLevel: "error",
    timeout: 7000,
    views: [
      // {
      //   namespace: "case-studies",
      //   beforeLeave(data) {
      //    // console.log("beforeLeave dino1");
      //  },
      // },
      // {
      //   namespace: "page-single-case",
      //   afterEnter(data) {
      //     //console.log("afterEnter dino3");
      //   },
      //  },
    ],
    transitions: [
      {
        name: "default",
        once(data) {
          // do something once on the initial page load

          initSmoothScroll(data.next.container);

          initScript();
          initCookieViews();

          initLoader();
        },
        async beforeLeave(data) {
          // Cerrar cualquier dropdown de SearchWP que haya quedado abierto
          if (typeof jQuery !== "undefined") {
            // El plugin usa esta clase para los resultados
            jQuery(".searchwp-live-search-results").remove();
          }
        },
        async leave(data) {
          // animate loading screen in
          pageTransitionIn(data.current);
          await delay(495);
          data.current.container.remove();
        },
        async enter(data) {
          // animate loading screen away
          pageTransitionOut(data.next);
          //initNextWord(data);
        },
        async beforeEnter(data) {
          const nextEl = data.next.container;
          if (nextEl) {
            //Just a little check to make sure we don't run this on an error
            // Find all scripts in the next container
            const nextScripts = nextEl.querySelectorAll("script");

            //Iterate over incoming script tags
            nextScripts.forEach((nextScript) => {
              const src = nextScript.src;
              if (src.includes("searchwp-live-ajax-search")) {
                return;
              }
              //Duplicate check - no need to re-execute scripts that are already loaded.
              if (
                document.head.querySelector('script[src="' + src + '"]') ==
                undefined
              ) {
                //Have to create a new script element in order for the browser to execute the code
                const newScript = document.createElement("script");
                newScript.src = src;
                newScript.async = true;
                document.head.append(newScript);

                nextScript.remove(); // Cleaning up the script in the container;
              }
            });
          }

          ScrollTrigger.getAll().forEach((t) => t.kill());

          //scroll.destroy();
          initSmoothScroll(data.next.container);
          initScript();

          gsap.globalTimeline.pause();

          //initAnimationsForNewElements(
          //  data.next.container.querySelectorAll(".col__image-wrap.fp")
          //);

          // Resume all animations
          gsap.globalTimeline.resume();

          //initMap();
          //initAcc();
        },
        afterEnter(data) {
          // 1. Usar el nombre de función correcto que vimos en el código fuente: searchwp_live_search
          if (
            typeof jQuery !== "undefined" &&
            typeof jQuery.fn.searchwp_live_search !== "undefined"
          ) {
            // 2. Ejecutar la inicialización sobre los inputs
            // Agregamos un pequeño delay para asegurar que Barba terminó de inyectar el HTML
            setTimeout(() => {
              const $searchInputs = jQuery('input[data-swplive="true"]');

              if ($searchInputs.length > 0) {
                // Reinicializamos el plugin
                $searchInputs.searchwp_live_search();

                // Log para que verifiques en consola que ahora sí entró
                console.log("SearchWP Live reiniciado con éxito");
              }
            }, 150);
          } else {
            console.error(
              "No se encontró la función jQuery.fn.searchwp_live_search",
            );
          }
          setTimeout(() => {
            initPlayVideoInview();
            ScrollTrigger.refresh(); // Crucial: obliga a GSAP a recalcular todo el DOM
          }, 500); // Ajusta este tiempo según lo que dure tu 'pageTransitionOut'
        },
      },
    ],
  });

  function initSmoothScroll(container) {
    //
    // LENIS SCROLL
    //
    const lenis = new Lenis({
      duration: 1.5,
      smoothWheel: true,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    //function raf(time) {
    //lenis.raf(time);
    //requestAnimationFrame(raf);
    //}
    //requestAnimationFrame(raf);

    document.querySelectorAll('a.goto[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        lenis.scrollTo(this.getAttribute("href"));
        $(".btn-hamburger").removeClass("active");
        $("main").removeClass("nav-active");
        $(".no-scroll-overlay").removeClass("active");
        $(".btn-click").removeClass("active");
      });
    });

    document.querySelectorAll('.goto a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        lenis.scrollTo(this.getAttribute("href"));
        $(".btn-hamburger").removeClass("active");
        $("main").removeClass("nav-active");
        $(".no-scroll-overlay").removeClass("active");
        $(".btn-click").removeClass("active");
      });
    });
  }

  ///////////////////
} //initPageTransitions()

function initNextWord(data) {
  // update Text Loading https://github.com/barbajs/barba/issues/507
  let parser = new DOMParser();
  let dom = parser.parseFromString(data.next.html, "text/html");
  let nextProjects = dom.querySelector(".loading-words");
  document.querySelector(".loading-words").innerHTML = nextProjects.innerHTML;
}

function delay(n) {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
}

/**
 * Fire all scripts on page load
 */
function initScript() {
  initWindowInnerheight();
  initCheckTouchDevice();
  initHamburgerNav();
  initScrolltriggerNav();
  initTricksWords();
  initLazyLoad();
  initPlayVideoInview();
  initScrolltriggerAnimations();
  initPopups();
  //initTabs();
  setTimeout(() => {
    initSwiper();
  }, 500);
  initMagneticButtons();
  refreshCartCount();
}

/**
 * Window Inner Height Check
 */
function initWindowInnerheight() {
  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  $(document).ready(function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    $(".btn-hamburger").click(function () {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  });
}

/**
 * Check touch device
 */
function initCheckTouchDevice() {
  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    $("main").addClass("touch");
    $("main").removeClass("no-touch");
  } else {
    $("main").removeClass("touch");
    $("main").addClass("no-touch");
  }
  $(window).resize(function () {
    if (isTouchScreendevice()) {
      $("main").addClass("touch");
      $("main").removeClass("no-touch");
    } else {
      $("main").removeClass("touch");
      $("main").addClass("no-touch");
    }
  });
}

/**
 * Hamburger Nav Open/Close
 */
/*
function initHamburgerNav() {
  //Hide menu on scroll
  /* var actionNav = gsap.to(".btn-hamburger", {
    yPercent: "-=180",
    duration: 0.25,
    ease: "power1.inOut",
    paused: true,
  });

  ScrollTrigger.create({
    trigger: ".btn-hamburger",
    start: "0px top",
    end: 99999,
    onUpdate: ({ progress, direction, isActive }) => {
      if (direction == -1) {
        actionNav.reverse();
      }
      if (direction == 1) {
        actionNav.play();
      } else if (direction == 1 && isActive == true) {
        actionNav.play();
      }
    },
  });


  // Open/close navigation when clicked .btn-hamburger
  if ($(window).width() < 456) {
    $(document).ready(function () {
      $(".btn-click").click(function () {
        if ($(".btn-hamburger").hasClass("active")) {
          $(".btn-hamburger").removeClass("active");
          $("main").removeClass("nav-active");
          $(".no-scroll-overlay").removeClass("active");
          //scroll.start();
        } else {
          $(".btn-hamburger").addClass("active");
          $("main").addClass("nav-active");
          $(".no-scroll-overlay").addClass("active");
          //scroll.stop();
        }
      });
      $(".no-scroll-overlay,.bot-menu").click(function () {
        $(".btn-hamburger").removeClass("active");
        $("main").removeClass("nav-active");
        $(this).removeClass("active");
        //scroll.start();
      });
    });

    //accordion
    document
      .querySelectorAll(".menu-item-has-children>a")
      .forEach((item) => item.setAttribute("data-barba-prevent", "self"));
    $(function () {
      var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        // Variables privadas
        var links = this.el.find(".menu-item-has-children > a");
        // Evento
        links.on(
          "click",
          { el: this.el, multiple: this.multiple },
          this.dropdown
        );
      };

      Accordion.prototype.dropdown = function (e) {
        e.preventDefault(); // Prevent the default link behavior

        var $el = e.data.el;
        var $this = $(this); // Declare $this variable using 'var'
        var $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass("open");

        if (!e.data.multiple) {
          $el
            .find(".sub-menu")
            .not($next)
            .slideUp()
            .parent()
            .removeClass("open");
        }
      };

      var accordion = new Accordion($(".mobile > .menu"), false);
    });
  } else {
    const listItems = document.querySelectorAll(".menu-item-has-children");

    listItems.forEach((item) => {
      item.addEventListener("mouseover", () => {
        item.classList.add("hovered");
      });

      item.addEventListener("mouseout", () => {
        item.classList.remove("hovered");
      });
    });
  }
}*/

/**
 * Hamburger Nav Open/Close
 */
function initHamburgerNav() {
  $(document).ready(function () {
    let activePanel = null;

    const openNavAndShowPanel = (panelType, focusSearch = false) => {
      $(".btn-hamburger").addClass("active");
      $("main").addClass("nav-active");
      $(".no-scroll-overlay").addClass("active");

      const panel = document.querySelector(
        `.nav-menu__panels [data-ref="nav-menu.${panelType}"]`,
      );
      const overlay = document.querySelector(".no-scroll-overlay");

      if (panel && overlay) {
        if (activePanel) {
          activePanel.style.display = "none";
        }

        panel.style.display = "block";
        activePanel = panel;
        overlay.style.display = "block";

        // Si se solicita enfocar la búsqueda y el panel es Main
        if (focusSearch && panelType === "Main") {
          // Pequeño retraso para asegurar que el panel esté visible
          setTimeout(() => {
            const searchInput = document.querySelector(
              '.buscar-container input[type="search"]',
            );
            if (searchInput) {
              searchInput.focus();
            }
          }, 700);
        }
      }
    };

    const closeNav = () => {
      $(".btn-hamburger").removeClass("active");
      $("main").removeClass("nav-active");
      $(".no-scroll-overlay").removeClass("active");
      $(".btn-click").removeClass("active");
    };

    // Click event listener para btn-click elements
    $(".btn-click").click(function () {
      const panelType = $(this).attr("data-panel-type");
      const isSearchIcon = $(this).find(".fa-magnifying-glass").length > 0;

      if (
        !$(".btn-hamburger").hasClass("active") ||
        panelType !== activePanel?.dataset.ref?.split(".")[1]
      ) {
        // Si es el ícono de búsqueda, pasamos el flag focusSearch = true
        openNavAndShowPanel(panelType, isSearchIcon);
      }

      $(".btn-click").removeClass("active");
      $(this).addClass("active");
    });

    // Click event listener para .close-container button
    $(".close-container").click(function () {
      if (!$(".btn-hamburger").hasClass("active")) {
        openNavAndShowPanel("Main");
      } else {
        closeNav();
      }
    });

    // Click event listener para no-scroll-overlay
    $(".no-scroll-overlay").click(closeNav);
    $(".nav-products a").click(closeNav);

    $(".contact-link").click(function (e) {
      e.preventDefault();
      const panelType = $(this).attr("data-panel-type");

      if (
        !$(".btn-hamburger").hasClass("active") ||
        panelType !== activePanel?.dataset.ref?.split(".")[1]
      ) {
        openNavAndShowPanel(panelType);
      }

      $(".btn-click").removeClass("active");
      $(this).addClass("active");
    });

    // Versión alternativa si el ícono de búsqueda está en un contenedor específico
    // Puedes también agregar un event listener específico para el contenedor de búsqueda
    $(
      ".social .btn-click[data-panel-type='Main'],.menu-mobile .btn-click[data-panel-type='Main']",
    ).click(function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevenir que el evento se propague si es necesario

      openNavAndShowPanel("Main", true);
    });
  });
}

/**
 * Cookie Views
 */
function initCookieViews() {
  // Set cookie for columns/rows view
  // https://www.youtube.com/watch?v=rfwiyBoVwdQ&ab_channel=TimothyRicks
  if (Cookies.get("view") == "columns") {
    //scroll.update();
    ScrollTrigger.refresh();
  }
}

/**
 * Scrolltrigger Scroll Check
 */
function initScrolltriggerNav() {
  ScrollTrigger.create({
    start: "top -30%",
    onUpdate: (self) => {
      $("main").addClass("scrolled");
    },
    onLeaveBack: () => {
      $("main").removeClass("scrolled");
    },
  });
}

/**
 * Scrolltrigger Nav
 */
function initTricksWords() {
  // Copyright start
  // © Code by T.RICKS, https://www.tricksdesign.com/
  // You have the license to use this code in your projects but not redistribute it to others
  // Tutorial: https://www.youtube.com/watch?v=xiAqTu4l3-g&ab_channel=TimothyRicks

  // Find all text with .tricks class and break each letter into a span
  var spanWord = document.getElementsByClassName("span-lines");
  for (var i = 0; i < spanWord.length; i++) {
    var wordWrap = spanWord.item(i);
    wordWrap.innerHTML = wordWrap.innerHTML.replace(
      /(^|<\/?[^>]+>|\s+)([^\s<]+)/g,
      '$1<span class="span-line"><span class="span-line-inner">$2</span></span>',
    );
  }
}

/**
 * Lazy Load
 */
function initLazyLoad() {
  // https://github.com/locomotivemtl/locomotive-scroll/issues/225
  // https://github.com/verlok/vanilla-lazyload
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });
}

/***
 Play Video Inview
*/

function isInsidePinnedSection(el) {
  return el.closest(".scroll-section");
}

function initPlayVideoInview() {
  ScrollTrigger.getAll().forEach((t) => {
    if (t.vars.id === "video-inview") t.kill();
  });

  let allVideoDivs = gsap.utils.toArray(".playpauze");

  allVideoDivs.forEach((videoDiv) => {
    let videoElem = videoDiv.querySelector("video");
    if (!videoElem) return;

    // 🎯 SI está dentro de una sección pinneada → desktop
    if (isInsidePinnedSection(videoElem) && window.innerWidth >= 1024) {
      videoElem.play().catch(() => {});
      return;
    }

    // 📱 Mobile / secciones normales
    ScrollTrigger.create({
      id: "video-inview",
      trigger: videoDiv, // 👈 NO el video
      start: "top 80%",
      end: "bottom 20%",
      onEnter: () => videoElem.play(),
      onEnterBack: () => videoElem.play(),
      onLeave: () => videoElem.pause(),
      onLeaveBack: () => videoElem.pause(),
    });
  });

  ScrollTrigger.refresh();
}

/**
 * Scrolltrigger Animations Desktop + Mobile
 */
function initScrolltriggerAnimations() {
  /////////////////////////

  let sectionsSeq = gsap.utils.toArray("section#quienes-intro");

  sectionsSeq.forEach((section) => {
    let video = section.querySelector("video.video-scroll");
    video ? initVideoScroll(section, video) : initOther(section);
  });

  function initVideoScroll(section, video) {
    video.pause();
    video.currentTime = 0;

    //    ScrollTrigger.matchMedia({
    // 🖥️ DESKTOP (igual que antes)
    /* "(min-width: 1024px)": function () {
        let splitInstances;
        let lines;
        let maxProgress = 0;

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            pin: true,
            scrub: 0.5,
            end: "+=200%",
            onUpdate: (self) => {
              maxProgress = Math.max(maxProgress, self.progress);
              if (video.duration) {
                video.currentTime = video.duration * maxProgress;
              }
            },
            onRefresh: () => {
              if (splitInstances) {
                splitInstances.forEach((s) => s.revert());
              }

              splitInstances = gsap.utils
                .toArray(".split", section)
                .map((el) => new SplitText(el, { type: "lines" }));

              lines = splitInstances.flatMap((s) => s.lines);
              gsap.set(lines, { autoAlpha: 0, y: 30 });

              tl.clear();

              tl.to(
                lines,
                {
                  autoAlpha: 1,
                  y: 0,
                  duration: 0.3,
                  stagger: 0.1,
                  ease: "power2.out",
                  once: true,
                },
                0.2,
              );
            },
          },
        });

        video.addEventListener("loadedmetadata", () => {
          ScrollTrigger.refresh();
        });
      },*/

    // 📱 MOBILE / TABLET
    //"(max-width: 1023px)": function () {
    let hasPlayed = false;

    video.pause();
    video.currentTime = 0;
    video.loop = false;
    video.muted = true;
    video.playsInline = true;

    ScrollTrigger.create({
      trigger: section,
      start: "top 74%",
      once: true, // 🔥 clave
      // markers:true,
      onEnter: () => {
        if (!hasPlayed) {
          hasPlayed = true;
          video.play().catch(() => {});
        }
      },
    });
    /*const splitPArray = gsap.utils.toArray(".split");
        document.fonts.ready.then(function () {
          splitPArray.forEach((P) => {
            // Si está dentro de una scroll-section, la saltamos — se manejan aparte
            //if (P.closest(".scroll-section")) return;

            const splitP = new SplitText(P, { type: ["lines"] });
            const splitPParent = new SplitText(P, {
              type: ["lines"],
              linesClass: "lineParent",
            });

            gsap.set(".lineParent", { overflow: "hidden" });

            const hasFooClass = P.classList.contains("foo");

            gsap.from(splitP.lines, {
              yPercent: 105,
              stagger: 0.1,
              scrollTrigger: {
                trigger: splitP.lines,
                start: hasFooClass ? "top 99%" : "top 80%",
              },
            });
          });
        });*/
    //},
    //    });
  }
  /////////////////////
  if (document.querySelector("#productos-intro")) {
    /*function initVerticalStacking() {
      const serviceCards = gsap.utils.toArray("#productos-intro .item");
      const tituloContainer = document.querySelector(
        "#productos-intro .titulo-container",
      );
      const contadorCurrent = document.querySelector(
        "#productos-intro .contador-current",
      );
      // const animated = new Set();

      // 🔑 Espacio entre cards — ajusta este valor
      const CARD_GAP = "50vh";

      setTimeout(() => {
        gsap.set(serviceCards, { willChange: "transform" });

        serviceCards.forEach((card, index) => {
          gsap.set(card, { zIndex: index + 1 });

          // Espacio debajo de cada card excepto el último
          if (index < serviceCards.length - 1) {
            card.style.marginBottom = CARD_GAP;
          }
        });

        // Estado inicial
        serviceCards.forEach((card) => {
          gsap.set(
            [card.querySelector(".thumb"), card.querySelector(".box")].filter(
              Boolean,
            ),
            {
              opacity: 0,
              // y: "50%",
            },
          );
        });
        //gsap.set(
          //[
            //serviceCards[0]?.querySelector(".thumb"),
            //serviceCards[0]?.querySelector(".box"),
          //].filter(Boolean),
          //{ opacity: 1, y: "0%" },
        //);
        //animated.add(serviceCards[0]);

        // Pin título
        ScrollTrigger.create({
          trigger: "#productos-intro",
          start: "top top",
          end: "bottom bottom",
          pin: tituloContainer,
          pinSpacing: false,
        });

        //if (window.innerWidth >= 1024) {
        const totalCards = serviceCards.length;

        serviceCards.forEach((card, index) => {
          const originalTop = parseFloat(gsap.getProperty(card, "top")) || 0;
          const originalBorderRadius =
            parseFloat(gsap.getProperty(card, "borderRadius")) || 0;

          let scaleEnd = 1;
          let topEnd = originalTop;
          let borderRadiusEnd = originalBorderRadius;

          if (index !== totalCards - 1) {
            const ratio = (totalCards - 1 - index) / (totalCards - 1);
            // scaleEnd = 1 - 0.15 * ratio;
            // topEnd = originalTop + 50 * ratio;
            // borderRadiusEnd = originalBorderRadius + 120 * ratio;
          }

          const thumb = card.querySelector(".thumb");
          const box = card.querySelector(".box");

          ScrollTrigger.create({
            trigger: card,
            start: "top 30%", // ajusta % según qué tan antes quieres que empiece
            once: true, // solo una vez
            //onEnter: () => {
                //if (!animated.has(card)) {
                  //animated.add(card);
                  //gsap.fromTo(
                    //[thumb, box].filter(Boolean),
                    //{ opacity: 0, y: "50%" },
                    //{
                      //opacity: 1,
                      //y: "0%",
                      //duration: 0.9,
                      //ease: "power2.out",
                      //stagger: 0.2,
                    //},
                  //);
                //}
              //},
            onEnter: () => {
              gsap.fromTo(
                [thumb, box].filter(Boolean),
                { opacity: 0, y: "0%" },
                {
                  opacity: 1,
                  //y: "0%",
                  duration: 0.9,
                  ease: "power2.out",
                  stagger: 0.2,
                },
              );
            },
          });

          ScrollTrigger.create({
            trigger: card,
            start: "top top+=0",
            end: "top top+=0",
            endTrigger: "#productos-intro .item-last",
            scrub: true,
            pin: true,
            pinSpacing: false,
            fastScrollEnd: true,

            onEnter: () => {
              if (contadorCurrent)
                contadorCurrent.textContent = card.dataset.index;
            },
            onEnterBack: () => {
              if (contadorCurrent)
                contadorCurrent.textContent = card.dataset.index;
            },
            onLeaveBack: () => {
              if (contadorCurrent && index > 0) {
                contadorCurrent.textContent =
                  serviceCards[index - 1].dataset.index;
              }
            },
            onUpdate: (self) => {
              const progress = self.progress;
              gsap.set(card, {
                // scale: 1 + (scaleEnd - 1) * progress,
                transformOrigin: "top center",
                // top: originalTop + (topEnd - originalTop) * progress + "px",
                //// borderRadius:
                //  originalBorderRadius +
                //  (borderRadiusEnd - originalBorderRadius) * progress +
                //  "px",
              });
            },
          });
        });
        //}
        ScrollTrigger.refresh();
      }, 500);
    }*/
    function initVerticalStacking() {
      // 1. Seleccionamos SOLO los items dentro del wrapper de destacadas
      const serviceCards = gsap.utils.toArray(".destacadas-wrapper .item");
      if (serviceCards.length === 0) return;

      const tituloContainer = document.querySelector(".titulo-container");
      const contadorCurrent = document.querySelector(".contador-current");
      const CARD_GAP = "50vh";

      setTimeout(() => {
        // Aplicar margen inferior a las destacadas para el efecto stack
        serviceCards.forEach((card, index) => {
          gsap.set(card, { zIndex: index + 1 });
          if (index < serviceCards.length - 1) {
            card.style.marginBottom = CARD_GAP;
          }
        });

        // Pin del título (solo mientras dure la sección de destacadas)
        ScrollTrigger.create({
          trigger: ".destacadas-wrapper",
          start: "top top",
          end: "bottom bottom",
          pin: tituloContainer,
          pinSpacing: false,
        });
        // Estado inicial
        serviceCards.forEach((card) => {
          gsap.set(
            [card.querySelector(".thumb"), card.querySelector(".box")].filter(
              Boolean,
            ),
            {
              opacity: 0,
              // y: "50%",
            },
          );
        });

        serviceCards.forEach((card, index) => {
          const thumb = card.querySelector(".thumb");
          const box = card.querySelector(".box");

          // Animación de entrada (Fade in)
          ScrollTrigger.create({
            trigger: card,
            start: "top 30%",
            once: true,
            onEnter: () => {
              gsap.fromTo(
                [thumb, box].filter(Boolean),
                { opacity: 0 },
                { opacity: 1, duration: 0.9, stagger: 0.2 },
              );
            },
          });

          // Efecto Pinning (Stacking)
          ScrollTrigger.create({
            trigger: card,
            start: "top top",
            endTrigger: ".destacadas-wrapper .item-last", // Importante terminar en la última destacada
            end: "top top",
            pin: true,
            pinSpacing: false,
            scrub: true,
            onEnter: () => {
              if (contadorCurrent)
                contadorCurrent.textContent = card.dataset.index;
            },
            onEnterBack: () => {
              if (contadorCurrent)
                contadorCurrent.textContent = card.dataset.index;
            },
          });
        });

        ScrollTrigger.refresh();
      }, 500);
    }

    initVerticalStacking();
    //window.addEventListener("resize", () => ScrollTrigger.refresh());

    //jQuery(document).ready(function($) {
    // Función para cerrar todos los acordeones excepto el especificado
    function closeAllAccordionsExcept(currentHeader) {
      $(".accordion-header")
        .not(currentHeader)
        .each(function () {
          var $header = $(this);
          var $content = $header.next(".accordion-content");

          $header.removeClass("active");
          $content.slideUp(300);
        });
    }

    // Manejar clic en categorías de nivel 1 con hijos (abre/cierra acordeón)
    $('.accordion-header[data-tiene-hijos="true"]').on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $header = $(this);
      var $content = $header.next(".accordion-content");

      // Cerrar todos los demás acordeones
      closeAllAccordionsExcept($header);

      // Toggle el actual
      $header.toggleClass("active");

      if ($content.is(":visible")) {
        $content.slideUp(300);
      } else {
        $content.slideDown(300);
      }
    });

    // Manejar clic en categorías de nivel 1 sin hijos (redirigen)
    $('.accordion-header[data-tiene-hijos="false"]').on("click", function (e) {
      var $this = $(this);
      // Buscar si hay un enlace dentro y redirigir
      var $link = $this.find("a.cat-link");
      if ($link.length) {
        window.location.href = $link.attr("href");
      }
    });

    // Manejar clic en los enlaces de categoría de nivel 2
    $(".subcat-nivel2 .cat-link").on("click", function (e) {
      e.stopPropagation(); // Solo prevenimos propagación, permitimos navegación
    });

    // Prevenir que el click en el contenido cierre el acordeón
    $(".accordion-content").on("click", function (e) {
      e.stopPropagation();
    });
    //});
  }

  // Disable GSAP on Mobile
  // Source: https://greensock.com/forums/topic/26325-disabling-scrolltrigger-on-mobile-with-mediamatch/
  ScrollTrigger.matchMedia({
    // Desktop Only Scrolltrigger
    "(min-width: 721px)": function () {
      if (document.querySelector(".scroll-section")) {
        const scrollSection = document.querySelectorAll(".scroll-section");
        scrollSection.forEach((section) => {
          const wrapper = section.querySelector(".wrapper");
          const items = wrapper.querySelectorAll(".item");
          const solucionesContainer = section.querySelector(
            ".soluciones-container",
          );

          // Contar soluciones reales (sin .empty)
          const solucionesReales = section.querySelectorAll(
            ".solucion:not(.empty)",
          );
          const emptyEl = section.querySelector(".solucion.empty");

          // Si hay menos de 2 soluciones reales, eliminar el .empty
          if (solucionesReales.length < 3 && emptyEl) {
            emptyEl.remove();
            solucionesContainer.classList.add("justify-center");
          }

          // Re-query después del posible remove
          const soluciones = section.querySelectorAll(".solucion");

          let direction = null;
          if (section.classList.contains("vertical-section"))
            direction = "vertical";
          else if (section.classList.contains("horizontal-section"))
            direction = "horizontal";

          initScroll(
            section,
            items,
            direction,
            soluciones,
            solucionesContainer,
          );
        });

        function initScroll(
          section,
          items,
          direction,
          soluciones,
          solucionesContainer,
        ) {
          // Split de todos los .split-txt dentro de la sección
          const splitLines = new Map(); // ← Map en lugar de {}

          section.querySelectorAll(".split-txt").forEach((P) => {
            const splitP = new SplitText(P, { type: ["lines"] });
            new SplitText(P, { type: ["lines"], linesClass: "lineParent" });
            gsap.set(P.querySelectorAll(".lineParent"), { overflow: "hidden" });
            gsap.set(splitP.lines, { yPercent: 105 });
            splitLines.set(P, splitP); // ← .set() en lugar de []
          });

          function getScrollDistance() {
            return solucionesContainer.scrollWidth - window.innerWidth;
          }

          const DELAY_PX = window.innerHeight;

          function getTotalScrollPx() {
            return window.innerHeight + getScrollDistance() + DELAY_PX;
          }

          items.forEach((item, index) => {
            if (index !== 0) {
              direction === "horizontal"
                ? gsap.set(item, { xPercent: 100 })
                : gsap.set(item, { yPercent: 100 });
            }
          });

          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              pin: true,
              start: "top top",
              end: () => `+=${getTotalScrollPx()}`,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            defaults: { ease: "none" },
          });

          // 1. Entrada del segundo item
          items.forEach((item, index) => {
            if (index < items.length - 1) {
              direction === "horizontal"
                ? timeline.to(items[index + 1], {
                    xPercent: 0,
                    duration: window.innerHeight,
                  })
                : timeline.to(items[index + 1], {
                    yPercent: 0,
                    duration: window.innerHeight,
                  });
            }
          });

          // 2. Animar splits del .intro cuando el item entra (al inicio del scroll horizontal)
          const introSplits = [];
          section.querySelectorAll(".intro .split-txt").forEach((P) => {
            if (splitLines.has(P)) introSplits.push(...splitLines.get(P).lines); // ← .has() y .get()
          });

          if (introSplits.length) {
            timeline.to(
              introSplits,
              {
                yPercent: 0,
                stagger: 0.1,
                duration: window.innerHeight * 0.5,
              },
              "<",
            ); // ← junto con la entrada del item
          }

          // 3. Scroll horizontal del container
          if (solucionesContainer) {
            const horizontalTween = timeline.to(solucionesContainer, {
              x: () => -getScrollDistance(),
              ease: "none",
              duration: () => getScrollDistance(),
            });

            // 4. Splits de cada .solucion — se animan escalonados durante el scroll horizontal
            /*   const solucionesArray = Array.from(soluciones).filter(
            (s) => !s.classList.contains("empty"),
          );
          const totalDuration = getScrollDistance();
          const stepDuration = totalDuration / solucionesArray.length;

         solucionesArray.forEach((solucion, i) => {
            const lines = [];
            solucion.querySelectorAll(".split-txt").forEach((P) => {
              if (splitLines.has(P)) lines.push(...splitLines.get(P).lines); // ← igual
            });

            if (lines.length) {
              // cada solucion anima sus líneas cuando llega al centro del viewport
              timeline.to(
                lines,
                {
                  yPercent: 0,
                  stagger: 0.16,
                  duration: stepDuration * 1.5,
                },
                `>-${totalDuration - stepDuration * i - stepDuration * 0.9}`,
              );
            }
          });*/
          }

          // 5. Delay final
          timeline.to({}, { duration: DELAY_PX });
        }
      }
    }, // End Desktop Only Scrolltrigger

    // Mobile Only Scrolltrigger
    "(max-width: 720px)": function () {
      if (document.querySelector(".split-txt-mobile")) {
        const splitPArray = gsap.utils.toArray(".split-txt-mobile");
        document.fonts.ready.then(function () {
          splitPArray.forEach((P) => {
            // Si está dentro de una scroll-section, la saltamos — se manejan aparte
            //if (P.closest(".scroll-section")) return;

            const splitP = new SplitText(P, { type: ["lines"] });
            const splitPParent = new SplitText(P, {
              type: ["lines"],
              linesClass: "lineParent",
            });

            gsap.set(".lineParent", { overflow: "hidden" });

            const hasFooClass = P.classList.contains("foo");

            gsap.from(splitP.lines, {
              yPercent: 105,
              stagger: 0.1,
              scrollTrigger: {
                trigger: splitP.lines,
                start: hasFooClass ? "top 99%" : "top 80%",
              },
            });
          });
        });
      }
    }, // End Mobile Only Scrolltrigger

    // 4k Only Scrolltrigger
    "(min-width: 2560px)": function () {}, // End Mobile Only Scrolltrigger
  }); // End GSAP Matchmedia
  // IMAGES SINGLE PARALLAX

  // ---------- card parallax effect
  /**/
  const cards = document.querySelectorAll(".card");

  cards.forEach((card) => {
    gsap.to(card.querySelector(".card-cover"), {
      yPercent: 25,
      ease: "none",
      scrollTrigger: {
        trigger: card,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  // DATA SCROLL
  const sections = document.querySelectorAll("[data-scroll]");

  sections.forEach((section, index) => {
    /* gsap.to(section, {
            //autoAlpha: 1,
            scrollTrigger: {
                trigger: section,
                start: 'top bottom-=200',
                toggleActions: 'play none none reverse',
                  markers: true
            }
        });*/

    ScrollTrigger.create({
      trigger: section,
      id: index + 1,
      start: "top 75%",
      //end: () => `+=${section.clientHeight + 30}`,
      toggleActions: "play reverse none reverse",
      toggleClass: { targets: section, className: "is-inview" },
      once: true,
      clearProps: true,
      // markers: true
    });
  });
  // Part 2
  const sections2 = document.querySelectorAll("[data-scroll-50]");

  sections2.forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      id: index + 1,
      start: "top 40%",
      //end: () => `+=${section.clientHeight + 30}`,
      toggleActions: "play reverse none reverse",
      toggleClass: { targets: section, className: "is-inview" },
      once: true,
      clearProps: true,
      // markers: true
    });
  });

  ///////////////////////////////////////
  const splitPArray = gsap.utils.toArray(".split-line");
  document.fonts.ready.then(function () {
    splitPArray.forEach((P) => {
      // Si está dentro de una scroll-section, la saltamos — se manejan aparte
      //if (P.closest(".scroll-section")) return;

      const splitP = new SplitText(P, { type: ["lines"] });
      const splitPParent = new SplitText(P, {
        type: ["lines"],
        linesClass: "lineParent",
      });

      gsap.set(".lineParent", { overflow: "hidden" });

      const hasFooClass = P.classList.contains("foo");

      gsap.from(splitP.lines, {
        yPercent: 105,
        stagger: 0.1,
        scrollTrigger: {
          trigger: splitP.lines,
          start: hasFooClass ? "top 99%" : "top 80%",
        },
      });
    });
  });

  /////////////////////
  if ($(".anim-container").length) {
    gsap.utils.toArray(".anim-container").forEach((container) => {
      gsap.from(container.querySelectorAll(".anim-item"), {
        y: 120,
        //scale: 1,
        duration: 1.25,
        scrollTrigger: {
          trigger: container,
          start: "top 45%", // Más abajo que "top center" para mayor seguridad
          end: "bottom 25%",
          toggleActions: "play none none none",
          //markers: true, // Puedes quitarlo en producción
          once: true, // Descomenta si solo quieres que se ejecute una vez
          //scrub: 1,       // Descomenta para sincronización suave con el scroll
        },
        ease: "Expo.easeOut", // Nota: "expo.out" es la sintaxis moderna (GSAP 3+)
        stagger: {
          from: "start",
          amount: 0.75,
        },
        opacity: 0,
      });

      gsap.from(container.querySelectorAll(".anim-item-ns"), {
        y: 120,
        duration: 1.25,
        scrollTrigger: {
          trigger: container,
          start: "top 80%", // Más abajo que "top center" para mayor seguridad
          end: "bottom 25%",
          toggleActions: "play none none none",
          //markers: true, // Puedes quitarlo en producción
          once: true, // Descomenta si solo quieres que se ejecute una vez
          //scrub: 1,       // Descomenta para sincronización suave con el scroll
        },
        ease: "Expo.easeOut", // Nota: "expo.out" es la sintaxis moderna (GSAP 3+)
        stagger: {
          from: "start",
          amount: 0.75,
        },
        opacity: 0,
      });
    });
  }

  /////////////////////////////////////////////////////////////////////

  ///////////
}

function initPopups() {
  $(
    '#entry-content a[href*=".jpg"],#entry-content a[href*=".webp"],  #entry-content a[href*=".jpeg"],  #entry-content a[href*=".png"],  #entry-content a[href*=".gif"],  a.popup-img',
  ).each(function () {
    if ($(this).parents(".gallery").length === 0) {
      $(this).magnificPopup({
        type: "image",
        fixedContentPos: false,
        closeOnContentClick: true,
        tLoading: '<div id="loader2">Cargando...</div>',
        mainClass: "mfp-zoom-out",
        removalDelay: 500,
      });
    }
  });

  /*/ $(
    ".hentry .gallery, .planos-container .img-container,.fotos .swiper-container,#galeria-viaje ul  "
  ).each(function () {
    $(this).magnificPopup({
      tLoading: '<div id="loader2">Cargando...</div>',
      mainClass: "mfp-zoom-out",
      removalDelay: 500,
      fixedContentPos: false,
      delegate: "li a",
      type: "image",
      gallery: {
        tCounter: "%curr% de %total%",
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
      },
    });
  });*/
  // Show more button functionality
  $("#show-more").on("click", function () {
    $(".gallery-list .hidden").slideToggle();
    //$(this).hide(); // Hide the button after expanding
    if ($(this).text() === "Ver todas las fotos") {
      $(this).text("Ver menos");
    } else {
      $(this).text("Ver todas las fotos");
    }
    setTimeout(() => {
      //scroll.update();
      ScrollTrigger.refresh();
    }, 3600);
  });

  $(".gallery-list").magnificPopup({
    delegate: "a.popup-image, a.popup-video", // Selector para ambos tipos
    type: "image", // Tipo por defecto
    tLoading: '<div id="loader2">Cargando...</div>',
    mainClass: "mfp-zoom-out",
    removalDelay: 500,
    fixedContentPos: false,
    gallery: {
      tCounter: "%curr% de %total%",
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
    },
    callbacks: {
      elementParse: function (item) {
        // Detectar tipo de contenido dinámicamente
        const href = item.el.attr("href");
        const dataType = item.el.attr("data-type");

        if (
          dataType === "video" ||
          href.includes(".mp4") ||
          href.includes(".mov") ||
          href.includes(".avi")
        ) {
          // Es un video
          item.type = "inline";
          item.src =
            '<div class="mfp-video-holder"><video controls autoplay style=""><source src="' +
            href +
            '" type="video/mp4">Tu navegador no soporta videos HTML5.</video></div>';
        } else {
          // Es una imagen
          item.type = "image";
        }
      },
      beforeOpen: function () {
        // Pausar todos los videos cuando se abra el popup
        $("video").each(function () {
          this.pause();
        });
      },
      close: function () {
        // Pausar video al cerrar popup
        $(".mfp-video-holder video").each(function () {
          this.pause();
        });
      },
    },
  });
}

/**
 * SLIDERS
 */
function initSwiper() {
  //swiper-home
  let SwiperTop = new Swiper(".swiper--ins", {
    spaceBetween: 0,
    centeredSlides: false,
    speed: 900,

    slideToClickedSlide: true,
    loop: true,
    loopFillGroupWithBlank: true,

    slidesPerView: 1,
    allowTouchMove: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    navigation: {
      nextEl: "#home .slideNext-btn",
      prevEl: "#home .slidePrev-btn",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"> </span>';
      },
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    breakpoints: {
      640: {
        spaceBetween: 0,
        slidesPerView: 1,
      },
    },
  });

  const SwiperTop2 = document.querySelectorAll(".swiper-slide");
  if (SwiperTop2.length <= 1) {
    // Hide the navigation buttons by targeting their CSS classes
    const prevButton = document.querySelector("#home .slideNext-btn");
    const nextButton = document.querySelector("#home .slidePrev-btn");
    if (prevButton) prevButton.style.display = "none";
    if (nextButton) nextButton.style.display = "none";
  }

  if ($(".productos-slider").length) {
    // Iterar sobre cada slider encontrado
    $(".productos-slider").each(function (index) {
      const novsContainer = this;
      if (!novsContainer) return;

      const swiperWrapper = novsContainer.querySelector(
        ".productos-slider .swiper-wrapper",
      );

      // ✅ Evitar clonado repetido
      if (!swiperWrapper.dataset.cloned) {
        const originalSlides = swiperWrapper.querySelectorAll(".swiper-slide");
        const totalSlides = originalSlides.length;
        const clones = 3;

        for (let j = 0; j < clones; j++) {
          originalSlides.forEach((slide) => {
            swiperWrapper.appendChild(slide.cloneNode(true));
          });
        }

        swiperWrapper.dataset.cloned = "true"; // Marca que ya se clonaron
      }

      // ✅ Destruir Swiper si ya existía para este contenedor específico
      if (
        novsContainer.swiper &&
        typeof novsContainer.swiper.destroy === "function"
      ) {
        evencontainer.swiper.destroy(true, true);
      }

      // ✅ Inicializar Swiper para este contenedor específico
      novsContainer.swiper = new Swiper(novsContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        loopAdditionalSlides: 1, // Number of slides to duplicate on each side of the loop
        speed: 1000,
        parallax: true,
        autoplay: {
          delay: 3000 + index * 500, // 6s, 7.5s, 9s, 10.5s, etc.
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: $(novsContainer)
            .closest(".vidrieras-container")
            .find(".slideNext-btn")[0],
          prevEl: $(novsContainer)
            .closest(".vidrieras-container")
            .find(".slidePrev-btn")[0],
        },
        on: {
          init: () => {
            // Refresh ScrollTrigger when Swiper is initialized
            ScrollTrigger.refresh();
          },
        },
        breakpoints: {
          960: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          1900: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 30,
          },
          2559: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 30,
          },
        },
      });
    });
  }
  ScrollTrigger.matchMedia({
    // Mobile Only Scrolltrigger
    "(max-width: 720px)": function () {
      let SwiperGaleria = new Swiper(".swiper--galeria", {
        spaceBetween: 0,
        speed: 900,
        direction: "horizontal",
        autoplay: {
          delay: 24000,
          disableOnInteraction: false,
        },
        loop: false, // Set to false to avoid looping
        slidesPerView: 1,
        allowTouchMove: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          init: function () {
            // Calculate total slides based on loop setting
            const totalSlides = this.params.loop
              ? this.slides.length - this.loopedSlides * 2
              : this.slides.length;
            document.querySelector(".swiper-counter").innerText =
              `1 / ${totalSlides}`;
          },
          slideChange: function () {
            // Update counter on slide change
            const currentSlide = this.realIndex + 1;
            const totalSlides = this.params.loop
              ? this.slides.length - this.loopedSlides * 2
              : this.slides.length;
            document.querySelector(".swiper-counter").innerText =
              `${currentSlide} / ${totalSlides}`;
          },
        },
      });

      // Initialize the counter on page load
      document.addEventListener("DOMContentLoaded", function () {
        const totalSlides =
          SwiperGaleria.slides.length - SwiperGaleria.loopedSlides * 2;
        document.querySelector(".swiper-counter").innerText =
          `1 / ${totalSlides}`;
      });
    }, // End Mobile Only Scrolltrigger
  });
}

/**
 * Magnetic Buttons
 */

// Función para actualizar el contador desde el servidor
function refreshCartCount() {
  const cartSpan = document.querySelector(".js-cart-count");
  if (!cartSpan) return;

  fetch(my_ajax_obj.ajaxurl + "?action=get_cart_count")
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        cartSpan.innerText = data.data.cart_count;
      }
    })
    .catch((err) => console.error("Error recuperando contador:", err));
}

function initMagneticButtons() {
  ////////////////////

  const form = document.querySelector(".add-to-quote-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const productId = form.querySelector('[name="product_id"]').value;
      const quantity = form.querySelector('[name="quantity"]').value;
      const nominal = form.querySelector(
        '[name="seccion_nominal_select"]',
      ).value;

      const ajaxUrl = my_ajax_obj.ajaxurl + "?nocache=" + new Date().getTime();

      fetch(ajaxUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `action=add_to_quote&product_id=${productId}&quantity=${quantity}&nominal=${nominal}`,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            // 1. Mostrar mensaje de éxito
            const feedback = document.querySelector(".quote-feedback");
            // feedback.innerText = "Producto agregado al presupuesto.";
            feedback.classList.add("active");

            // 2. ACTUALIZAR EL CONTADOR (Aquí está la clave)
            // Buscamos el span que creamos en el shortcode
            const cartCountSpan = document.querySelector(".js-cart-count");
            if (cartCountSpan) {
              cartCountSpan.innerText = data.data.cart_count;
            }

            // Opcional: animar el icono para que el usuario note el cambio
            document.querySelector(".quote-cart-icon").classList.add("bump");
            setTimeout(() => {
              document
                .querySelector(".quote-cart-icon")
                .classList.remove("bump");
            }, 600);
          }
        });
    });
    document
      .querySelector(".quote-feedback .cerrar")
      .addEventListener("click", function () {
        document.querySelector(".quote-feedback").classList.remove("active");
      });
  }
  ///////////////////////////////////
  const clearBtn = document.getElementById("clear-quote-btn");
  if (clearBtn) {
    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (confirm("¿Estás seguro que deseas borrar el presupuesto?")) {
        fetch(my_ajax_obj.ajaxurl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "action=clear_quote_cart",
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              location.reload();
            } else {
              alert("No se pudo borrar  el presupuesto.");
            }
          })
          .catch(() => {
            alert("Error al conectar con el servidor.");
          });
      }
    });
  }
  ///////////////////////////////////////

  const mobileBtn = document.getElementById("toggle-sidebar-mobile");
  const menuContainer = document.querySelector(".accordion-menu");
  if (mobileBtn && menuContainer) {
    mobileBtn.addEventListener("click", function () {
      menuContainer.classList.toggle("is-visible-mobile");

      // Cambiar el texto o signo del botón
      const span = this.querySelector("span");
      if (menuContainer.classList.contains("is-visible-mobile")) {
        span.textContent = "-";
      } else {
        span.textContent = "+";
      }
    });
  }
  if (menuContainer) {
    menuContainer.addEventListener("click", function (e) {
      if (e.target.classList.contains("toggle-btn")) {
        e.preventDefault();
        const btn = e.target;
        const parentLi = btn.closest(".item-nivel");
        const subMenu = parentLi.querySelector(".sub-menu-accordion");
        const isOpening =
          subMenu.style.display === "none" || subMenu.style.display === "";

        if (isOpening) {
          // --- Lógica de Colapso (Cerrar hermanos) ---
          const siblings = parentLi.parentElement.querySelectorAll(
            ":scope > .item-nivel.is-open",
          );
          siblings.forEach((sibling) => {
            if (sibling !== parentLi) {
              sibling.classList.remove("is-open");
              const siblingMenu = sibling.querySelector(".sub-menu-accordion");
              const siblingBtn = sibling.querySelector(".toggle-btn");
              if (siblingMenu) siblingMenu.style.display = "none";
              if (siblingBtn) siblingBtn.textContent = "+";
            }
          });

          // Abrir el actual
          subMenu.style.display = "block";
          parentLi.classList.add("is-open");
          btn.textContent = "-";
        } else {
          // Cerrar el actual
          subMenu.style.display = "none";
          parentLi.classList.remove("is-open");
          btn.textContent = "+";
        }
      }
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 300);
    });
  }

  ///////////////////////
  var shareButtons = document.querySelectorAll(".share-btn");

  if (shareButtons) {
    [].forEach.call(shareButtons, function (button) {
      button.addEventListener("click", function (event) {
        var width = 650,
          height = 450;

        event.preventDefault();

        window.open(
          this.href,
          "Share Dialog",
          "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            (screen.height / 1.5 - height / 1.5) +
            ",left=" +
            (screen.width / 1.5 - width / 1.5),
        );
      });
    });
  }

  //https://api.whatsapp.com/send?text=". window.location.href
  var URLactual = "https://api.whatsapp.com/send?text=" + window.location.href;
  //alert(URLactual);

  $("#wsp-share").attr("href", URLactual);

  document.querySelectorAll(".copy-link-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const url = this.dataset.url;
      navigator.clipboard
        .writeText(url)
        .then(function () {
          alert("Enlace copiado al portapapeles");
        })
        .catch(function (err) {
          const textArea = document.createElement("textarea");
          textArea.value = url;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          alert("Enlace copiado al portapapeles");
        });
    });
  });
}
////////////////////////////////////////////////////////////////////////

// Helper function
let domReady = (cb) => {
  document.readyState === "interactive" || document.readyState === "complete"
    ? cb()
    : document.addEventListener("DOMContentLoaded", cb);
};

domReady(() => {
  // Display body when DOM is loaded
  document.body.style.background = "#fff";
  document.body.style.visibility = "visible";
});

/* // =============================================
// FORZAR LINKS A LOCALHOST:3000 (compatible con Barba)
// =============================================
setTimeout(() => {
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link) return;

    let href = link.getAttribute("href");
    if (!href) return;

    // Si ya está en localhost:3000, no hacer nada
    if (href.includes("localhost:3000")) return;

    // Si es un link interno de WordPress
    if (href.includes("localhost/andielco")) {
      e.preventDefault();
      href = href.replace("localhost/andielco", "localhost:3000");

      // Usar Barba si está disponible
      if (window.barba && !link.hasAttribute("data-barba-prevent")) {
        window.barba.go(href);
      } else {
        window.location.href = href;
      }
    }
  });
}, 300);

// También interceptar los que Barba no captura
window.addEventListener("popstate", function () {
  if (window.location.href.includes("localhost/andielco")) {
    const newUrl = window.location.href.replace(
      "localhost/andielco",
      "localhost:3000",
    );
    history.replaceState(null, "", newUrl);
  }
});*/

var gfInstanceCounter = 0;

/* ─── Parche idempotente ─── */
function patchGrecaptcha() {
  if (
    typeof grecaptcha === "undefined" ||
    !grecaptcha.render ||
    grecaptcha.__patched
  )
    return;
  var _orig = grecaptcha.render;
  grecaptcha.render = function (container, params, inherit) {
    var el =
      typeof container === "string"
        ? document.getElementById(container)
        : container;
    if (el && el.querySelector("iframe")) {
      return +(el.getAttribute("data-widget-id") || 0);
    }
    try {
      var wid = _orig.call(grecaptcha, container, params, inherit);
      if (el) el.setAttribute("data-widget-id", wid);
      return wid;
    } catch (e) {
      if (e.message && e.message.indexOf("already been rendered") !== -1) {
        return +(el && el.getAttribute("data-widget-id")) || 0;
      }
      throw e;
    }
  };
  grecaptcha.__patched = true;
}

/* ─── Destruye widgets antes de reinyectar ─── */
function destroyRecaptchaIn($wrap) {
  if (typeof grecaptcha === "undefined") return;
  $wrap.find(".ginput_recaptcha").each(function () {
    var wid = $(this).attr("data-widget-id");
    if (wid !== undefined) {
      try {
        grecaptcha.reset(+wid);
      } catch (e) {}
    }
    $(this).empty().removeAttr("data-widget-id");
  });
}

/* ─── Uniquifica TODOS los IDs internos del form por instancia ─── */
function uniquifyFormIds(html, uid) {
  var s = "--i" + uid;

  return (
    html
      // IDs del wrapper y form
      .replace(/id="gform_wrapper_(\d+)"/g, 'id="gform_wrapper_$1' + s + '"')
      .replace(/id="gform_(\d+)"/g, 'id="gform_$1' + s + '"')
      .replace(
        /id="gform_submit_button_(\d+)"/g,
        'id="gform_submit_button_$1' + s + '"',
      )

      // data-form-index y data-parent-form para que GF no confunda instancias
      .replace(/data-form-index="(\d+)"/g, 'data-form-index="$1' + s + '"')
      .replace(/data-parent-form="([\d_]+)"/g, 'data-parent-form="$1' + s + '"')

      // IDs de campos individuales
      .replace(/id="(field_\d+_\d+)"/g, 'id="$1' + s + '"')
      .replace(/id="(input_\d+[^"]*)/g, 'id="$1' + s + '"')
      .replace(/for="(input_\d+[^"]*)/g, 'for="$1' + s + '"')

      // El contenedor de reCAPTCHA — selector clave: ginput_recaptcha
      .replace(/id="(ginput_recaptcha_[^"]+)"/g, 'id="$1' + s + '"')
      .replace(
        /data-recaptcha-container="([^"]+)"/g,
        'data-recaptcha-container="$1' + s + '"',
      )

      // Referencias internas de GF al wrapper por ID en atributos
      .replace(/(gform_wrapper_\d+)(?=[^"]*")/g, "$1" + s)
  );
}

/* ─── Renderiza reCAPTCHA manualmente — selector correcto ─── */
function renderRecaptchaIn($wrap, callback) {
  if (typeof grecaptcha === "undefined" || !grecaptcha.render) {
    setTimeout(function () {
      renderRecaptchaIn($wrap, callback);
    }, 200);
    return;
  }

  $wrap.find(".ginput_recaptcha").each(function () {
    var $el = $(this);
    if ($el.find("iframe").length) return; // ya renderizado

    var sitekey = $el.attr("data-sitekey");
    if (!sitekey) return;

    try {
      var wid = grecaptcha.render(this, {
        sitekey: sitekey,
        theme: $el.attr("data-theme") || "light",
        size: $el.attr("data-size") || "normal",
        tabindex: $el.attr("data-tabindex") || 0,
        callback: $el.attr("data-callback") || undefined,
        "expired-callback": $el.attr("data-expired-callback") || undefined,
        "error-callback": $el.attr("data-error-callback") || undefined,
      });
      $el.attr("data-widget-id", wid);
      console.log(
        "✓ reCAPTCHA renderizado en:",
        $el.attr("id"),
        "widget:",
        wid,
      );
    } catch (e) {
      console.warn("✗ reCAPTCHA error:", e.message);
    }
  });

  if (callback) callback();
}

/* ─── Carga un form-wrap individual, devuelve Promise ─── */
function loadGravityForm($wrap) {
  return new Promise(function (resolve) {
    var $gfItem = $wrap.find(".gfid");
    if (!$gfItem.length) {
      resolve();
      return;
    }

    destroyRecaptchaIn($wrap);

    var gfId = parseInt($gfItem.attr("data-id"));
    var gfTitle = $gfItem.attr("data-title");
    var gfDesc = $gfItem.attr("data-descr");
    var gfAjax = $gfItem.attr("data-ajax");
    var postId = $wrap.attr("data-post-id");

    $.ajax({
      type: "GET",
      url: ajax.url,
      data: {
        action: "load_gravity_form",
        formid: gfId,
        formtitle: gfTitle,
        formdescr: gfDesc,
        formajax: gfAjax,
        post_id: postId,
      },
      dataType: "json",
    })
      .done(function (response) {
        gfInstanceCounter++;
        patchGrecaptcha();

        // Uniquifica TODOS los IDs antes de inyectar
        var formHtml = uniquifyFormIds(response.form, gfInstanceCounter);
        $wrap.html(formHtml);

        $wrap.append(
          '<input type="hidden" name="post_title" value="' +
            response.post_title +
            '">',
        );

        // Deja que el MutationObserver de GF intente primero
        // luego forzamos render manual si no lo hizo
        setTimeout(function () {
          renderRecaptchaIn($wrap, resolve);
        }, 500);
      })
      .fail(function () {
        resolve();
      });
  });
}

/* ─── Carga secuencial ─── */
async function initGravityForms() {
  var $wraps = $(".form-wrap");
  for (var i = 0; i < $wraps.length; i++) {
    await loadGravityForm($($wraps[i]));
  }
  setTimeout(function () {
    ScrollTrigger.refresh();
  }, 400);
}

/* ─── Hooks Barba.js v2 ─── */
barba.hooks.beforeEnter(function () {
  $(".form-wrap").each(function () {
    destroyRecaptchaIn($(this));
  });
});
barba.hooks.afterEnter(function () {
  initGravityForms();
});

initGravityForms();

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});
